<script>
import ChampionCard from "@/components/2025/Champions/ChampionCard.vue";

export default {
name: "ChampionsList",
  components: {ChampionCard},
  data(){
  return {
    champions: {
      eafc24:{
        img:require("@/assets/imgs/2025/champs/eafc-champ.png"),
        game: "EA FC 24",
        first:{
          prize: "45.000 Dhs",
          name: "Nizar SADKI",
        },
        second:{
          prize: "25.000 Dhs",
          name: "Adam haberraih",
        },
        third:{
          prize: "10.000 Dhs",
          name: "Aymane ouardi",
        }
      },
      lol:{
        img:require("@/assets/imgs/2025/champs/lol-champ.png"),
        game: "League of legends",
        first:{
          prize: "90.000 Dhs",
          name: "Void Walkers",
        },
        second:{
          prize: "40.000 Dhs",
          name: "Washed Noobs",
        },
        third:{
          prize: "20.000 Dhs",
          name: "Lgergoussi",
        }
      },
      pubg:{
        img:require("@/assets/imgs/2025/champs/pubg-champ.png"),
        game: "PUBG Mobile",
        first:{
          prize: "60.000 Dhs",
          name: "CRYPTICSS",
        },
        second:{
          prize: "36.000 Dhs",
          name: "1 Bullet",
        },
        third:{
          prize: "28.000 Dhs",
          name: "OCEANS ON FIRE",
        }
      }
    }
  }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4 mb-3 px-3 px-md-2" v-for="(champsItem, key) in champions" :key="key">
      <ChampionCard :champs-item="champsItem" ></ChampionCard>
    </div>
  </div>
</template>

<style scoped>
</style>